"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJoinCondition = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const ColumnsSelector_1 = __importDefault(require("./ColumnsSelector"));
const StyledOperator = styled_components_1.default.div `
  margin-left: 6px;
  margin-right: 6px;
  .MuiOutlinedInput-adornedEnd {
    padding-right: 8px;
  }
  .MuiInputBase-root {
    width: 42px;
  }
  .MuiInputBase-input {
    padding-left: 9px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
`;
const StyledPopper = (0, styled_components_1.default)(core_1.Popper) `
  width: 56px !important;
`;
const operators = [
    { value: '=' },
    { value: '>' },
    { value: '>=', label: '\u2265' },
    { value: '<' },
    { value: '<=', label: '\u2264' },
    { value: '<>' }
];
function parseJoinCondition(condition) {
    let columnCount = 0;
    return condition.split(' ').map(value => {
        const isOperator = operators.some(operator => operator.value === value);
        const isColumn = !isOperator;
        // even columnCount values will use columnMaps from parent query
        const forParent = isColumn && columnCount++ % 2 === 0;
        return {
            value,
            forParent,
            type: isOperator ? 'operator' : 'column'
        };
    });
}
exports.parseJoinCondition = parseJoinCondition;
const JoinCondition = props => {
    const { vertical, condition, joinAttribute, expressionMap, onChange } = props;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const joinAlias = joinAttribute.alias.name;
    // get cached column maps or get using subquery config/expressionMap
    const queryAliasColumnMap = (0, react_1.useMemo)(() => {
        return expressionMap
            ? queryManager.getQueryAliasColumnMap(expressionMap)
            : queryManager.queryAliasColumnMap;
        // re-evaluate when queryManager.queryAliasColumnMap changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expressionMap, queryManager, queryManager.queryAliasColumnMap]);
    const queryColumnMap = (0, react_1.useMemo)(() => {
        return queryAliasColumnMap.filter(columnMap => joinAlias !== columnMap.alias);
    }, [joinAlias, queryAliasColumnMap]);
    const subQueryColumnMap = (0, react_1.useMemo)(() => {
        return queryAliasColumnMap.filter(columnMap => joinAlias === columnMap.alias);
    }, [joinAlias, queryAliasColumnMap]);
    const parts = (0, react_1.useMemo)(() => {
        const parts = parseJoinCondition(condition);
        // default parts if no condition is set
        if (parts.length < 3) {
            return [
                { type: 'column', value: '', forParent: true },
                { type: 'operator', value: '=' },
                { type: 'column', value: '' }
            ];
        }
        return parts;
    }, [condition]);
    const handleChange = (part, index, value) => {
        const copy = Array.from(parts);
        copy.splice(index, 1, Object.assign(Object.assign({}, part), { value }));
        const condition = copy.map(part => part.value).join(' ');
        onChange === null || onChange === void 0 ? void 0 : onChange(condition);
    };
    const renderPart = (part, index) => {
        const update = (value) => handleChange(part, index, value);
        switch (part.type) {
            case 'column': {
                const columnMap = part.forParent ? queryColumnMap : subQueryColumnMap;
                return (react_1.default.createElement(ColumnsSelector_1.default, { value: part.value, vertical: vertical, config: expressionMap, queryAliasColumnMap: columnMap, onChange: column => {
                        var _a, _b;
                        // handle default value
                        let value = Array.isArray(column) ? column[0] : column;
                        value = value || ((_a = columnMap[0]) === null || _a === void 0 ? void 0 : _a.path) || ((_b = columnMap[0]) === null || _b === void 0 ? void 0 : _b.value) || '';
                        update(value);
                    } }));
            }
            case 'operator': {
                const operator = operators.find(operator => operator.value === part.value) ||
                    operators[0];
                return (react_1.default.createElement(StyledOperator, null,
                    react_1.default.createElement(lab_1.Autocomplete, { popupIcon: '', disableClearable: true, value: operator, options: operators, PopperComponent: StyledPopper, getOptionLabel: option => option.label || option.value, onChange: (_, value) => update(value.value), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { size: 'small', variant: 'outlined' }))) })));
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, parts.map((part, index) => (react_1.default.createElement(react_1.Fragment, { key: index }, renderPart(part, index))))));
};
exports.default = JoinCondition;
//# sourceMappingURL=JoinCondition.js.map